import { Component, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { EmployeeService } from 'src/app/services/employee.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { FormGroup, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { Router } from '@angular/router';
import { FormlyFormOptions, FormlyFieldConfig } from '@ngx-formly/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  profileData = null
  selectedStations = []
  selectedLanguageids = []
  superAdmins = [];
  profile_form: FormGroup;
  change_password_form: FormGroup;
  isStationManager;
  allStations = null;
  allLanguages = null

  oldPasswordHide = false;
  newPasswordHide = false;
  confirmPasswordHide = false;
  submitted = false
  letters: any;

  form = new FormGroup({});
  model: any = {};
  options: FormlyFormOptions = {};
  fields: FormlyFieldConfig[] = [
    {
      key: 'oldpassword',
      type: 'input',
      templateOptions: {
        label: 'Old Password',
        type: 'password',
        required: true,
        placeholder: 'Please enter current password',
      }
    },
    {
      key: 'newpassword',
      validators: {
        fieldMatch: {
          expression: (control) => {
            const value = control.value;
            return !(value.confirmpassword != value.newpassword);
          },
          message: 'Password Not Matching',
          errorPath: 'confirmpassword',
        }
      },
      fieldGroup: [
        {
          key: 'newpassword',
          type: 'input',
          templateOptions: {
            type: 'password',
            label: 'New Password',
            placeholder: 'Must be at least 6 characters',
            required: true,
            minLength: 6,
            maxLength: 15,
          },
          validators: {
            //validation: [Validators.pattern('^(?=.{6,})(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$]).*$')],
            patternMatch: {
              expression: (c) => !c.value || /^(?=.{6,})(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$]).*$/.test(c.value),
              message: (error, field: FormlyFieldConfig) => `Password must contain at least one uppercase, one lowercase, one number and one special character ($,@,#)`
            }
          },
        },
        {
          key: 'confirmpassword',
          type: 'input',
          templateOptions: {
            type: 'password',
            label: 'Confirm Password',
            placeholder: 'Please re-enter your password',
            required: true,
          },
        },
        // {
        //   key: 'select_multi',
        //   type: 'ui-select-multiple',
        //   templateOptions: {
        //     label: 'Select Multiple',
        //     placeholder: 'Placeholder',
        //     description: 'Description',
        //     required: true,
        //     multiple: true,
        //     selectAllOption: 'Select All',
        //     options: [
        //       { value: 1, label: 'Option 1' },
        //       { value: 2, label: 'Option 2' },
        //       { value: 3, label: 'Option 3' },
        //       { value: 4, label: 'Option 4' },
        //     ],
        //   },
        // },
      ],
    }



  ];

  cpsubmit() {
    if (this.form.valid) {
      alert(JSON.stringify(this.model));
    }
  }

  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private spinner: NgxSpinnerService,
    private notifier: NotifierService,
    private employeeService: EmployeeService,
    private authService: AuthenticationService) { }


  ngOnInit() {
    this.isStationManager = this.authService.isStationAdmin()
    this.spinner.show()
    if (this.authService.isStationAdmin()) {
      this.getStationManagerProfile()
      this.initProfileForm()
      this.initChangePasswordForm()
    } else {
      this.getSuperAdminProfile()
      this.initProfileForm()
      this.initChangePasswordForm();
      this.getUsers();
    }
  }

  initProfileForm() {
    this.profile_form = new FormGroup({
      empid: new FormControl({ value: '', disabled: true }),
      email: new FormControl({ value: '', disabled: true }),
      firstname: new FormControl({ value: '', disabled: true }),
      lastname: new FormControl({ value: '', disabled: true }),
      mobile: new FormControl({ value: '', disabled: true }),
      password: new FormControl({ value: '', disabled: true }),
      address: new FormControl({ value: '', disabled: true }),
      stations: new FormControl({ value: '', disabled: true }),
      languages: new FormControl({ value: '', disabled: true }),
      role: new FormControl({ value: '', disabled: true }),
      jobtype: new FormControl({ value: '', disabled: true }),
    });
  }

  initChangePasswordForm() {
    this.change_password_form = this.formBuilder.group({
      oldpassword: ['', Validators.required, , Validators.minLength(6), Validators.maxLength(15)],
      newpassword: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(15), Validators.pattern('^(?=.{6,})(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$]).*$')]],
      confirmpassword: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(15), Validators.pattern('^(?=.{6,})(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$]).*$')]],
    });
  }

  get profile_form_controls() { return this.profile_form.controls; }
  get f() { return this.change_password_form.controls; }


  getStationManagerProfile() {
    this.employeeService.getEmployeeById(this.authService.getCurrentUserId()).subscribe((res) => {
      this.spinner.hide()
      this.profileData = res['result'];
      this.setFormFields()
    })
  }

  async getCurrentPassword() {
    await this.employeeService.getEmployeeById(this.authService.getCurrentUserId()).subscribe((res) => {
      this.profileData = res['result'];
      return this.profileData.password;
    })
  }

  getSuperAdminProfile() {
    this.employeeService.getSuperAdminDetails(this.authService.getCurrentUserId()).subscribe((res) => {
      this.spinner.hide()
      this.profileData = res['result'];
      this.setFormFields()
    })
  }


  setFormFields() {
    this.allLanguages = this.profileData.language
    if (this.authService.isStationAdmin()) {
      this.profileData.language.forEach(language => {
        this.selectedLanguageids.push(language.languageId);
      });
      this.profileData.stations.forEach(station => {
        this.selectedStations.push(station.id);
      });
    }

    let x = this.profileData.firstname + " " + this.profileData.lastname;
    let nameparts = x.split(" ");
    let initials = nameparts[0].charAt(0).toUpperCase() + nameparts[1].charAt(0).toUpperCase();
    this.letters = initials;

    this.profile_form_controls.empid.setValue(this.profileData.emp_id)
    this.profile_form_controls.firstname.setValue(this.profileData.firstname)
    this.profile_form_controls.lastname.setValue(this.profileData.lastname)
    this.profile_form_controls.email.setValue(this.profileData.email)
    this.profile_form_controls.mobile.setValue(this.profileData.mobileno)
    this.profile_form_controls.password.setValue(this.profileData.password)
    this.profile_form_controls.address.setValue(this.profileData.address1 + ', ' + this.profileData.address2 + ', ' +
      this.profileData.city + ', ' + this.profileData.state + ', ' + this.profileData.country + ', ' + this.profileData.zipcode)
    this.profile_form_controls.stations.setValue(this.selectedStations)
    this.profile_form_controls.role.setValue(this.profileData.role)
    this.profile_form_controls.jobtype.setValue(this.profileData.job_type)
  }

  validation_messages = {
    'oldpassword': [
      { type: 'minlength', message: 'Old password must be minimum of 6 characters long.' },
      { type: 'maxlength', message: 'Old password should not exceed 15 characters.' },
      { type: 'required', message: 'Please enter old password.' },
      { type: 'pattern', message: 'Password must contain at least one uppercase, one lowercase, one number and one special character ($,@,#)' }
    ],
    'newpassword': [
      { type: 'minlength', message: 'New password must be 6 characters or more.' },
      { type: 'maxlength', message: 'New password should not exceed 15 characters.' },
      { type: 'required', message: 'Please enter new password.' },
      { type: 'pattern', message: 'Password must contain at least one uppercase, one lowercase, one number and one special character ($,@,#)' }

    ],
    'confirmpassword': [
      { type: 'minlength', message: 'New password must be 6 characters long.' },
      { type: 'required', message: 'Please enter new password to confirm.' },
      { type: 'maxlength', message: 'New password should not exceed 15 characters.' },
      { type: 'pattern', message: 'Password must contain at least one uppercase, one lowercase, one number and one special character ($,@,#)' }
    ],
  }

  submit(values) {
    this.submitted = true
    this.change_password_form.markAllAsTouched();
    if (this.change_password_form.invalid) {
      return;
    }

    if (this.profileData.password != values.oldpassword) {
      this.notifier.notify('danger', 'Please enter correct old password')
      return;
    } else if (values.newpassword != values.confirmpassword) {
      this.notifier.notify('danger', 'Both new password and confirm password should be same.')
      return;
    } else if (values.oldpassword == values.newpassword) {
      this.notifier.notify('danger', 'Old and new passwords are same.')
      return;
    }
    this.spinner.show()
    this.authService.changePassword(values.oldpassword, values.newpassword).subscribe(res => {
      this.spinner.hide()
      if (res['status']) {
        this.notifier.notify('success', res['message'])
        setTimeout(() => {
          this.router.navigateByUrl('/login')
        }, 1000);
      } else {
        this.notifier.notify('danger', res['message'])
      }
    })
  }

  onReset() {
    this.change_password_form.reset();
  }
  
  activePage
  searchText;
  getUsers() {
      this.employeeService.getUsers().subscribe(data => {
        if (data['result'] != null) {
          this.superAdmins = data['result'] as [];
          //this.superAdmins = this.superAdmins.reverse();
        }
      });
  }

  addAdmin() {
    this.router.navigateByUrl("home/add-admin");
  }

  editEmployee(employee) {
    this.router.navigate(["home/edit-admin", employee.id]);
  }


}
